import type { Access } from '@thinkalpha/access-ws-client/contracts/user.js';
import { doesAccessGrantAllowRequest } from '@thinkalpha/common/util/permissions.js';

/**
 * Access level at or above which a user may administer a firm's membership. Matches the literal
 * used by `useFirmEffectivePermission` and `thresholdPermission` in `@thinkalpha/backend-core`
 * (which the web bundle does not depend on).
 */
export const FIRM_ADMIN_THRESHOLD_PERMISSION = 'owner' as const;

export const hasFirmAdminAccess = (accessList: readonly Access[]): boolean =>
    accessList.some(
        (access) =>
            access.type === 'firm' && doesAccessGrantAllowRequest(access.permission, FIRM_ADMIN_THRESHOLD_PERMISSION),
    );
